import React from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const WidgetLoading = () => {
  const { t } = useLocalization();
  return (
    <div className="c7-widget__loading">
      {t('general.accessibility.loading')}
    </div>
  );
};

export default WidgetLoading;
